export const INITIAL_VALUES = {
  name: '',
  organization: '',
  email: '',
  message: '',
};

export const FIELDS = [
  {
    id: 'name',
    isMessage: false,
  },
  {
    id: 'organization',
    isMessage: false,
  },
  {
    id: 'email',
    isMessage: false,
  },
  {
    id: 'message',
    isMessage: true,
  },
];
